export class AnimationsManager {
	private queue: AnimationInterface[] = [];

	public add(animation: AnimationInterface) {
		animation.onAnimationOver(() => {
			this.runNext();
		});
		this.queue.push(animation);
		this.runNext();
	}

	private runNext() {
		if (this.queue.length > 0) {
			const animation = this.queue.shift();
			if (animation) {
				if (animation.getStatus() === 'stopped') {
					animation.animate();
				} else {
					this.queue.push(animation);
				}
			}
		}
	}
}
